import { Breadcrumbs, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const BreadcrumbDefecta = ({ isWarehouse }) => {
  const navigate = useNavigate();

  return (
    <div className="text-[12px] text-[#2C3E5D]">
      <Breadcrumbs
        sx={{ color: "#2C3E5D" }}
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" />}
      >
        <Link
          underline="hover"
          color="inherit"
          href="/profile"
          onClick={() => navigate("/profile")}
        >
          Home
        </Link>
        {window.location.pathname.includes("/defecta") ? (
          <Link
            underline="hover"
            color="inherit"
            href={`${isWarehouse ? "/central-warehouse" : ""}/defecta`}
            onClick={() =>
              navigate(`${isWarehouse ? "/central-warehouse" : ""}/defecta`)
            }
          >
            Defecta
          </Link>
        ) : null}
        {window.location.pathname.includes("/defecta/archive") ? (
          <Link
            underline="hover"
            color="inherit"
            href={`${isWarehouse ? "/central-warehouse" : ""}/defecta/archive`}
            onClick={() =>
              navigate(
                `${isWarehouse ? "/central-warehouse" : ""}/defecta/archive`
              )
            }
          >
            Arsip
          </Link>
        ) : null}
      </Breadcrumbs>
    </div>
  );
};

export default BreadcrumbDefecta;
